import "antd/dist/antd.css";
import React, { useState, useEffect, useReducer } from "react";
import { Card } from "antd";
import { initialState, reducer } from "./reducer";
import { useSelector } from "react-redux";
import SocialNetworksList from "./components/List";
import Header from "./components/Header";
import Edit from "./components/Edit";
import ProfileService from "../../../../services/Profile/ProfileService";


const get_social_account_data = (social_media_id, member_social_accounts) => {
    let account_name = '';
    let user_url = '';
    const found_social_acoounts = member_social_accounts.find(el => el.socialmedia.id === social_media_id)
    if (found_social_acoounts) {
        account_name = found_social_acoounts.account_name
        user_url = found_social_acoounts.user_url
    }

    const social_accounts_data = {
        account_name,
        user_url
    }
    return social_accounts_data;
}


const SocialNetworks = ({ id }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const token = useSelector((state) => state.Member.token);
    const [loading, setLoading] = useState();


    useEffect(() => {
        setLoading(true);
        ProfileService.getSocialAccountsList(token)
            .then((response) => {
                const member_social_accounts = response.data.social_accounts;
                const social_medias = response.data.social_medias;
                const social_accounts = social_medias.map((item) => {
                    const social_acount_data = get_social_account_data(item.id, member_social_accounts);
                    return { ...item, account_name: social_acount_data.account_name, user_url: social_acount_data.user_url };
                });
                const action = {
                    type: "set_social",
                    payload: {
                        social_accounts: social_accounts
                    },
                };
                dispatch(action);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    }, [token, state.filters]);


    const refreshList = () => {
        const action = {
            type: "refresh_list",
        };
        dispatch(action);
    };

    const onSuccess = () => {
        refreshList();
        updateIndexVisibility(0);
    };

    const updateIndexVisibility = (indexVisibility) => {
        const action = {
            type: "set_index_visibility",
            payload: indexVisibility,
        };
        dispatch(action);
    };


    return (
        <>
            <Card className="m-0 p-0" bodyStyle={{ padding: "0" }}>

                {
                    state.indexVisibility === 0 && (
                        <Header
                            totalPoint={state.totalPoints}
                            onAdd={() => updateIndexVisibility(1)}
                            onClose={() => updateIndexVisibility(0)}
                        />
                    )
                }

                {
                    state.indexVisibility === 0 && (
                        <SocialNetworksList
                            socialAccounts={state.social_accounts}
                            loading={loading}
                            onSuccess={onSuccess}
                        />
                    )
                }

                {
                    state.indexVisibility === 1 && (
                        <Edit
                            id={id}
                            socialAccounts={state.social_accounts}
                            onSuccess={onSuccess}
                            onClose={() => updateIndexVisibility(0)}
                        />
                    )
                }

            </Card>
        </>
    );
};
export default SocialNetworks;
